var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1665 2.49992H16.4998C16.7209 2.49992 16.9328 2.58772 17.0891 2.744C17.2454 2.90028 17.3332 3.11224 17.3332 3.33325V16.6666C17.3332 16.8876 17.2454 17.0996 17.0891 17.2558C16.9328 17.4121 16.7209 17.4999 16.4998 17.4999H1.49984C1.27882 17.4999 1.06686 17.4121 0.910582 17.2558C0.754301 17.0996 0.666504 16.8876 0.666504 16.6666V3.33325C0.666504 3.11224 0.754301 2.90028 0.910582 2.744C1.06686 2.58772 1.27882 2.49992 1.49984 2.49992H4.83317V0.833252H6.49984V2.49992H11.4998V0.833252H13.1665V2.49992ZM11.4998 4.16659H6.49984V5.83325H4.83317V4.16659H2.33317V7.49992H15.6665V4.16659H13.1665V5.83325H11.4998V4.16659ZM15.6665 9.16658H2.33317V15.8333H15.6665V9.16658Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLine);
export default __webpack_public_path__ + "static/media/calendar-line.4c0d3b505d834c1c2a76ff181fd65acc.svg";
export { ForwardRef as ReactComponent };